<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          :label="customLabel.pi_date || '单据日期'"
          v-model="form.main.pi_date"
          slot="pi_date"
        />
        <vendor-field
          slot="pi_vendname"
          :label="'供应商名称'"
          v-model="form.main.pi_vendname"
          @select="onSelectVend"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="pi_otherkind"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_otherkind || "类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.pi_otherkind"
              placeholder="请选择"
            >
              <option value="借贷">借贷</option>
              <option value="还贷">还贷</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="pi_repaygoods"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_repaygoods || "还货要求"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.pi_repaygoods"
              placeholder="请选择"
            >
              <option value="需要还">需要还</option>
              <option value="不用还">不用还</option>
            </select>
          </div>
        </div>
        <employee-field slot="pi_seller" :label="'业务员转出'" v-model="form.main.pi_seller" @select="onselectSeller"/>
        <employee-field slot="pi_inseller" :label="'业务员转入'" v-model="form.main.pi_inseller" @select="onselectInseller"/>
        <custom-field 
          :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" :caller="caller" fieldName="pi_text1"
          slot="pi_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" :caller="caller" fieldName="pi_text2"
          slot="pi_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" :caller="caller" fieldName="pi_text3"
          slot="pi_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" :caller="caller" fieldName="pi_text4"
          slot="pi_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" :caller="caller" fieldName="pi_text5"
          slot="pi_text5" hidden="true"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
             v-model="item.productDTO.pr_detail"
              @select="onItemSelectProduct($event, item)"
              :label="customLabel.pr_detail"
              slot="pr_detail"
            />
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.productDTO.pr_orispeccode }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_brand"
              slot="pr_brand"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_brand || "厂家/品牌"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.productDTO.pr_brand }}
              </div>
            </div>
            <warehouse-field
              slot="pd_whname"
              v-model="item.pd_whname"
              @select="onSelectWarehouse($event, item)"
              :label="customLabel.pd_whname || '调出仓库'"
            />
            <warehouse-field
              slot="pd_inwhname"
              v-model="item.pd_inwhname"
              @select="onSelectInWarehouse($event, item)"
              :label="customLabel.pd_inwhname || '调入仓库'"
            />
            <div class="weui-cell" slot="pd_outqty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_outqty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pd_outqty"
                  placeholder="请填写"
                />
              </div>
              <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
            </div>
          <custom-field 
            :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" :caller="caller" fieldName="pd_text1"
            slot="pd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" :caller="caller" fieldName="pd_text2"
            slot="pd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" :caller="caller" fieldName="pd_text3"
            slot="pd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" :caller="caller" fieldName="pd_text4"
            slot="pd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" :caller="caller" fieldName="pd_text5"
            slot="pd_text5" hidden="true"
          />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import VendorField from "@/components/field/VendorField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import ProductField from "@/components/field/ProductField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    DateField,
    VendorField,
    EmployeeField,
    ProductField,
    WarehouseField,
    CustomField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "MoveOutSeller",
      xtype: "sale-moveoutseller-formpanel",
      form: {
        main: {
          pi_class: "MOVEOUTSELLER"
        },
        items: [
          {
            productDTO: {},
          },
        ],
      },
    };
  },
  methods: {
    onSelectVend(selection) {
      var me = this,
        main = me.form.main;
      main.pi_vendid = selection.id;
      main.pi_vendcode = selection.ve_code;
      main.pi_vendname = selection.ve_name;
    },
    onselectSeller(selection) {
      var me = this,
        main = me.form.main;
      main.pi_sellerid = selection.id;
      main.pi_sellercode = selection.em_code;
      main.pi_seller = selection.em_name;
    },
    onselectInseller(selection) {
      var me = this,
        main = me.form.main;
      main.pi_insellerid = selection.id;
      // main.pi_sellercode = selection.em_code;
      main.pi_inseller = selection.em_name;
    },
    /**
     * 选择明细产品
     */
    onItemSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    onSelectWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    onSelectInWarehouse(selection, item) {
      item.pd_inwhid = selection.id;
      item.pd_inwhcode = selection.wh_code;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.pi_date) {
        me.$weui.topTips("请选择日期", 2000);
      } else if (!main.pi_otherkind) {
        me.$weui.topTips("请选择类型", 2000);
      } else if (!main.pi_seller) {
        me.$weui.topTips("请选择业务员转出", 2000);
      } else if (!main.pi_inseller) {
        me.$weui.topTips("请选择业务员转入", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.pd_prodcode) {
            me.$weui.topTips(`第${count + 1}行物料未选择`, 2000);
            return false;
          } else if (!item.pd_whname) {
            me.$weui.topTips(`第${count + 1}行调出仓库未选择`, 2000);
            return false;
          } else if (!item.pd_inwhname) {
            me.$weui.topTips(`第${count + 1}行调入仓库未选择`, 2000);
            return false;
          } else if (!item.pd_outqty || item.pd_outqty <= 0) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else {
            count++;
            item.pd_pdno = count;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        productDTO: {}
      });
    }
  },
};
</script>